'use client'

import { ButtonListItem } from 'fukku/ActionList/ListItem/ButtonListItem/ButtonListItem'
import { MODAL_TYPE, Modal, type ModalAPI } from 'fukku/Modal'
import type { GetQuestionResponse } from 'help/types/types'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import dynamic from 'next/dynamic'
import { useRef } from 'react'

const ModalHelpContent = dynamic(() =>
	import('help/components/ModalHelpContent/ModalHelpContent').then(
		(mod) => mod.ModalHelpContent
	)
)

export const ModalHelp = ({
	question,
}: {
	readonly question: GetQuestionResponse | null
}) => {
	const { t } = useLabels()
	const modalRef = useRef<ModalAPI>(null)

	if (!question) {
		return null
	}

	const questionContent = question.question

	const onClick = () => {
		modalRef.current?.show()
	}

	return (
		<>
			<ButtonListItem
				data-testid='myAccount.modalHelp'
				onClick={onClick}
				title={questionContent.title}
				showArrow={false}
			/>
			<Modal
				ref={modalRef}
				name='myAccount-help-modal'
				type={MODAL_TYPE.SHEET}
				title={t('profile.help.title')}
				showTitle={false}
			>
				<ModalHelpContent
					questionKey={questionContent.key}
					categoryKey={questionContent.categoryKey}
				/>
			</Modal>
		</>
	)
}
